<!-- @Author: ruiwang -->
<!-- @Date: 2024-02-24 17:38:21 -->
<!-- @Last Modified by: xiaodongyu -->
<!-- @Last Modified time: 2024-02-29 14:57:14 -->

<template>
    <register-layout :step="3">
        <div class="rs2">
            <h2 class="bold">
                本人確認書類の提出
            </h2>
            <section>
                <p class="b3 mt24">
                    会員本登録には、本人確認書類として下記をご提出ください。
                    各書類はアップロードにて提出いただけます。
                </p>
                <p class="b3">
                    （ご不明な点がございましたら、お問合せよりご連絡ください。）
                </p>
                <p class="b3 mt24">
                    ファイルサイズ：１ファイルあたり４Mb以内
                </p>
            </section>
            <section
                v-if="!isServer && form"
                class="mt60 fm-1"
            >
                <a-form
                    layout="vertical"
                    :form="form"
                    @submit.prevent="handleSubmit"
                >
                    <div class="step-tit">
                        <h4 class="bold">
                            Step 01.
                        </h4>
                        <div class="b2">
                            アップロードするファイルの種類を選択します。
                        </div>
                    </div>
                    <div class="tab-bar mb20 mt24">
                        <div
                            class="tab-bar-item b1"
                            :class="getActiveTabClass(0)"
                            @click="onTabChange(0)"
                        >
                            日本国籍のお客様の場合
                        </div>
                        <div
                            class="tab-bar-item b1"
                            :class="getActiveTabClass(1)"
                            @click="onTabChange(1)"
                        >
                            外国籍のお客様の場合
                        </div>
                    </div>
                    <section v-show="tab === 0">
                        <a-form-item class="custom-btn-radio-group-wrapper">
                            <a-radio-group
                                v-decorator="['jpUploadType', { rules: [{ required: true }] }]"
                                class="custom-card-radio-group"
                            >
                                <a-radio-button
                                    key="JP0"
                                    style="width: 100%;"
                                    value="JP0"
                                >
                                    <div class="flex-between">
                                        <div>
                                            <div class="b2">
                                                <icon-star class="star-icon icon-small" />
                                                個人番号カード（両面）
                                            </div>
                                            <div class="b4 tab-desc">
                                                1書類の提出のみで可
                                            </div>
                                        </div>
                                        <div class="tab-item-right flex">
                                            <img
                                                class="id-card"
                                                src="./img/id-card-front.png"
                                            >
                                            <img
                                                class="id-card ml12"
                                                src="./img/id-card-back.png"
                                            >
                                        </div>
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="JP1"
                                    value="JP1"
                                >
                                    <div class="dot b2">
                                        マイナンバー記載の住民票の写し
                                    </div>
                                    <div class="dot b2">
                                        運転免許証（両面）
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="JP2"
                                    value="JP2"
                                >
                                    <div class="dot b2">
                                        マイナンバー記載の住民票の写し
                                    </div>
                                    <div class="dot b2">
                                        各種健康保険証（両面）
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="JP3"
                                    value="JP3"
                                >
                                    <div class="dot b2">
                                        現住所・氏名記載の通知カード
                                    </div>
                                    <div class="dot b2">
                                        運転免許証（両面）
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="JP4"
                                    value="JP4"
                                >
                                    <div class="dot b2">
                                        現住所・氏名記載の通知カード
                                    </div>
                                    <div class="dot b2">
                                        各種健康保険証（両面）+住民票
                                    </div>
                                </a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                    </section>
                    <section v-show="tab === 1">
                        <a-form-item class="custom-btn-radio-group-wrapper">
                            <a-radio-group
                                v-decorator="['frUploadType', { rules: [{ required: true }] }]"
                                class="custom-card-radio-group"
                            >
                                <a-radio-button
                                    key="FR0"
                                    value="FR0"
                                    style="width: 100%;"
                                >
                                    <div class="flex-between">
                                        <div>
                                            <div class="dot b2">
                                                個人番号カード（両面）
                                            </div>
                                            <div class="dot b2">
                                                在留カード（両面）【推奨】
                                            </div>
                                        </div>
                                        <div class="tab-item-right flex pr10">
                                            <icon-star class="star-icon icon-big" />
                                        </div>
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="FR1"
                                    value="FR1"
                                    style="width: 100%;"
                                >
                                    <div class="flex-between">
                                        <div>
                                            <div class="dot b2">
                                                個人番号カード
                                            </div>
                                            <div class="dot b2">
                                                特別永住者証明書【推奨】
                                            </div>
                                        </div>
                                        <div class="tab-item-right flex pr10">
                                            <icon-star class="star-icon icon-big" />
                                        </div>
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="FR2"
                                    value="FR2"
                                >
                                    <div class="dot b2">
                                        マイナンバー記載の住民票の写し
                                    </div>
                                    <div class="dot b2">
                                        在留カード（両面）
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="FR3"
                                    value="FR3"
                                >
                                    <div class="dot b2">
                                        マイナンバー記載の住民票の写し
                                    </div>
                                    <div class="dot b2">
                                        特別永住者証明書
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="FR4"
                                    value="FR4"
                                >
                                    <div class="dot b2">
                                        現住所・氏名記載の通知カード
                                    </div>
                                    <div class="dot b2">
                                        在留カード（両面）
                                    </div>
                                </a-radio-button>
                                <a-radio-button
                                    key="FR5"
                                    value="FR5"
                                >
                                    <div class="dot b2">
                                        現住所・氏名記載の通知カード
                                    </div>
                                    <div class="dot b2">
                                        特別永住者証明書
                                    </div>
                                </a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                    </section>
                    <div class="step-tit">
                        <h4 class="bold">
                            Step 02.
                        </h4>
                        <div class="b2">
                            「ファイル選択」をクリックし、提出書類の画像を選択
                        </div>
                    </div>
                    <section class="controler-box mt20">
                        <a-form-item label="①種類目の本人確認書類">
                            <a-upload-dragger
                                v-decorator="genFileDecorator('frontPic')"
                                class="dragger-upload front"
                                :before-upload="beforeUpload"
                            >
                                <h5>
                                    証明書（表）
                                </h5>
                                <div class="b3">
                                    ファイルをアップロード
                                </div>
                            </a-upload-dragger>
                        </a-form-item>
                        <a-form-item style="padding-top: 28px;">
                            <a-upload-dragger
                                v-decorator="genFileDecorator('backPic')"
                                class="dragger-upload back"
                                :before-upload="beforeUpload"
                            >
                                <h5>
                                    証明書（裏）
                                </h5>
                                <div class="b3">
                                    ファイルをアップロード
                                </div>
                            </a-upload-dragger>
                        </a-form-item>
                        <a-form-item
                            v-show="showSecondUpload"
                            label="②種類目の本人確認書類"
                        >
                            <a-upload-dragger
                                v-decorator="genFileDecorator('frontPic2')"
                                class="dragger-upload front"
                                :before-upload="beforeUpload"
                            >
                                <h5>
                                    証明書（表）
                                </h5>
                                <div class="b3">
                                    ファイルをアップロード
                                </div>
                            </a-upload-dragger>
                        </a-form-item>
                        <a-form-item
                            v-show="showSecondUpload"
                            style="padding-top: 28px;"
                        >
                            <a-upload-dragger
                                v-decorator="genFileDecorator('backPic2')"
                                class="dragger-upload back"
                                :before-upload="beforeUpload"
                            >
                                <h5>
                                    証明書（裏）
                                </h5>
                                <div class="b3">
                                    ファイルをアップロード
                                </div>
                            </a-upload-dragger>
                        </a-form-item>
                    </section>
                    <a-form-item>
                        <button
                            :disabled="!canSubmit"
                            type="primary"
                        >
                            送信する
                        </button>
                    </a-form-item>
                </a-form>
            </section>
        </div>
        <template #tip>
            <div class="b1">
                <p>※確認書類は発行後3ヶ月以内・有効期限内のものを用意してください。</p>
                <p class="mid-tip">
                    ※確認書類は複数枚に渡る場合、すべてのページが必要となります。
                </p>
                <p>※官公署が発行する書類は公印のあるページが必要となります。</p>
            </div>
        </template>
    </register-layout>
</template>

<script>
import {isServer} from 'ssr-common/constant/config';

import RegisterLayout from '../component/register-layout';
import {fieldsMap, options1, options2, genOptions} from './fields';
import IconStar from './icon/star';

export default {
    name: 'RegisterStepUpload',

    components: {
        RegisterLayout,
        IconStar
    },

    data() {
        return {
            tab: 0,
            fieldsMap,
            options1,
            options2,
            form: null,
            isServer: isServer(),
            formData: null,
            canSubmit: false
        };
    },

    computed: {
        showSecondUpload() {
            const {tab, formData} = this;

            return tab !== 0 || formData?.jpUploadType !== 'JP0';
        },
    },

    mounted() {
        const {onValuesChange} = this;
        this.form = this.$form.createForm(this, {
            name: 'step2Upload',
            onValuesChange
        });
        this.$store.commit('finance/updateFinance', {
            currentStepRouteName: 'RegisterStep2-2'
        });
    },

    methods: {
        genOptions,

        normFile(e) {
            if (Array.isArray(e)) {
                return e[0];
            }

            return e?.fileList?.[0];
        },

        genFileDecorator(field) {
            return [field, {
                rules: [{required: true, message: ' '}],
                valuePropName: 'file',
                getValueFromEvent: e => {
                    if (Array.isArray(e)) {
                        return e[0];
                    }

                    return e?.fileList?.[0];
                }
            }];
        },

        onValuesChange(form, value, values) {
            this.formData = values;
            const {tab} = this;
            const dataRight = Object.keys(values).every(key => {
                const val = values[key];
                if (tab === 0 && key === 'frUploadType') return true;

                if (tab === 1 && key === 'jpUploadType') return true;

                if (values.jpUploadType === 'JP0' && ['frontPic2', 'backPic2'].includes(key)) {
                    return true;
                }

                return !!val;
            });
            this.canSubmit = dataRight;
        },

        onTabChange(tab) {
            this.tab = tab;
            this.form.setFieldsValue({jpUploadType: undefined, frUploadType: undefined});
        },

        beforeUpload() {
            return false;
        },

        getActiveTabClass(idx) {
            const isActive = this.tab === idx;

            return {
                'bold': isActive,
                'tab-bar-item-active': isActive
            };
        },

        handleSubmit() {
            const {canSubmit} = this;
            if (!canSubmit) return;

            this.$router.push({name: 'RegisterStep3'});
            /**
            this.form.validateFields((err, values) => {
                if (!err) {
                    // eslint-disable-next-line no-console
                    console.log('Received values of form: ', values);
                    this.$router.push({name: 'RegisterStep3'});
                }
            });
            */
        }
    }
};
</script>

<style lang="scss" scoped>
.rs2 {
    .propel-03 {
        color: $propel-03;
    }

    .ml12 {
        margin-left: 0.12rem;
    }

    .mt20 {
        margin-top: 0.2rem;
    }

    .mb20 {
        margin-bottom: 0.2rem;
    }

    .mt24 {
        margin-top: 0.24rem;
    }

    .mt28 {
        margin-top: 0.28rem;
    }

    .mb28 {
        margin-bottom: 0.28rem;
    }

    .mt60 {
        margin-top: 0.6rem;
    }

    .pr10 {
        padding-right: 0.1rem;
    }

    .pt24 {
        padding-top: 0.24rem;
    }

    .pt28 {
        padding-top: 0.28rem;
    }

    .email {
        width: fit-content;
        display: flex;
        align-items: center;
        padding: 0.1rem 0.2rem;
        background-color: $grey-01;
        border-radius: 0.12rem;
    }

    .fm {
        border: 1px solid blue;
    }

    &-bg {
        position: sticky;
        top: 1.2rem;
        border: 1px solid red;
        width: 5.56rem;
        height: 7rem;
    }

    .controler-box {
        display: flex;
        flex-wrap: wrap;

        .ant-form-item {
            width: calc(50% - 0.15rem);
            margin-bottom: 0.24rem;

            &:nth-child(odd) {
                margin-right: 0.3rem;
            }
        }
    }

    .step-tit {
        display: flex;
    }

    .tab-bar {
        display: flex;
        padding: 0.06rem;
        border-radius: 0.12rem;
        background-color: $grey-01;

        &-item {
            padding: 0.06rem;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.08rem;
            cursor: pointer;

            &:first-child {
                margin-right: 0.06rem;
            }
        }

        &-item-active {
            background-color: $c-09;
        }
    }

    .dragger-upload {
        ::v-deep {
            .ant-upload.ant-upload-drag {
                border: none;
                height: 1.68rem;
                border-radius: 0.16rem;
            }
        }

        &.front {
            ::v-deep {
                .ant-upload.ant-upload-drag {
                    background-color: $gold-01;
                }
            }
        }

        &.back {
            ::v-deep {
                .ant-upload.ant-upload-drag {
                    background-color: $grey-01;
                }
            }
        }
    }
}

.mid-tip {
    margin: 0.2rem 0;
}

.dot {
    display: flex;
    align-items: center;

    &::before {
        content: "";
        margin-right: 0.08rem;
        background-color: $green-03;
        display: block;
        width: 0.08rem;
        height: 0.08rem;
        border-radius: 50%;
    }
}

.icon-small {
    width: 0.12rem;
    height: 0.12rem;
}

.icon-big {
    width: 0.2rem;
    height: 0.2rem;
}

.star-icon {
    fill: $green-03;
}

.tab-desc {
    color: $propel-03;
}

.ant-radio-button-wrapper-checked {
    .star-icon {
        fill: $c-09;
    }

    .tab-desc {
        color: $c-09;
    }

    .dot {
        &::before {
            background-color: $c-09;
        }
    }
}

.flex {
    display: flex;
    align-items: center;
}

.flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.id-card {
    width: 1rem;
}

</style>
